var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","align-center":""}},[_c('ComponentRegister')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }